import { selectOrganizationId, usePostEventMutation } from '@carboncopyco/data';
import { EventAction, EventTarget } from '@carboncopyco/types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

export const usePageEvent = () => {
  const organizationId = useSelector(selectOrganizationId);
  const { workspaceId } = useParams<{
    workspaceId?: string;
  }>();
  const { pathname } = useLocation();
  const [postEvent] = usePostEventMutation();

  return useEffect(() => {
    postEvent({
      organizationId,
      path: pathname,
      workspaceId,
      action: EventAction.VISITED,
      target: EventTarget.PAGE,
    });
  }, [workspaceId, pathname, postEvent, organizationId]);
};
